import {NgModule} from '@angular/core';
import {SharedModule} from '@shared/shared.module';
import {AuthLayoutComponent} from './auth-layout/auth-layout.component';
import {PipeModule} from '@shared/pipes/pipe.module';
import {NzLayoutModule} from 'ng-zorro-antd/layout';
import {NzMenuModule} from 'ng-zorro-antd/menu';
import {FullLayoutComponent} from './full-layout/full-layout.component';
import {SharedComponentsModule} from '@shared/components/shared-components.module';
import {NgxsModule} from '@ngxs/store';
import {AuthState} from '@shared/state/auth/auth.state';
import {VehicleState} from '@shared/state/vehicle/vehicle.state';
import {AlertState} from '@shared/state/alert/alert.state';
import {ReportState} from '@shared/state/report/report.state';
import {UserState} from '@shared/state/user/user.state';
import {MlState} from '@shared/state/ml/ml.state';
import {SingleLayoutComponent} from './single-layout/single-layout.component';

@NgModule({
  declarations: [AuthLayoutComponent, FullLayoutComponent, SingleLayoutComponent],
  imports: [
    SharedModule,
    PipeModule,
    NzLayoutModule,
    NzMenuModule,
    SharedComponentsModule,
    NgxsModule.forFeature([AuthState, VehicleState, AlertState, ReportState, UserState, MlState])
  ],
  providers: []
})
export class LayoutModule {
}
